export default "__VITE_ASSET__BGRsCX$K__"